import { StringColumn } from 'baseui/data-table';

export const COL_NAMES = {
	segmentName: 'segmentName',
	bonusUtil: 'bonusUtil',
	cashbackUtil: 'cashbackUtil'
};

export const columnConfigs = [
	StringColumn({
		title: 'Segment Name',
		mapDataToValue: (data: any) => data[COL_NAMES.segmentName]
	}),
	StringColumn({
		title: 'Bonus Util %',
		minWidth: 400,
		mapDataToValue: (data: any) => data[COL_NAMES.bonusUtil]
	}),
	StringColumn({
		title: 'Cashback  Util %',
		mapDataToValue: (data: any) => data[COL_NAMES.cashbackUtil]
	})
];
